import React from 'react';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import ContactForm from '../components/ContactForm';
import { COMPANY_INFO } from '../data/siteData';

export default function EnglishPage() {
  return (
    <>
      <SEO
        title="English - Hærvejens Træpleje"
        description="Contact Hærvejens Træpleje – Certified Tree Care in East Jutland and the Triangle Region. Fully insured and certified arborists."
        canonical="https://xn--hrvejenstrpleje-xlbj.dk/english/"
        ogImage="https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/traefaeldning-i-vejle.jpg"
      />

      <Breadcrumbs items={[{ label: 'English' }]} />

      <section className="bg-[#10271c] text-white py-14 sm:py-20 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-xs font-bold text-[#7dd2a6] bg-[#1a3d2c] px-3.5 py-1.5 rounded-full inline-block mb-4">
            English information
          </span>
          <h1 className="text-3xl sm:text-5xl font-bold tracking-tight mb-4">
            Contact Hærvejens Træpleje – Certified Tree Care in East Jutland and the Triangle Region
          </h1>
          <p className="text-base sm:text-lg text-[#cadcd1] leading-relaxed max-w-2xl mx-auto">
            Welcome to the English contact page for Hærvejens Træpleje. We are your professional partner for safe, expert, and gentle tree care.
          </p>
        </div>
      </section>

      <section className="py-14 sm:py-20 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7 space-y-6 text-[#35483d] text-base leading-relaxed">
            <div className="rounded-2xl overflow-hidden border border-[#dce5df] mb-6">
              <img
                src="https://assets.auxodev.dk/assets/3d990fe3-1622-47f2-aa75-fd8032eebfed/mathias-svendsen-1-1024x768.jpg"
                alt="Mathias Svendsen - Owner"
                className="w-full h-auto object-cover"
              />
            </div>

            <p>
              Our team consists of 12 experienced and certified arborists, trained at the Danish Forestry College (Skovskolen). We place the highest value on good craftsmanship, thorough advice, and absolute safety.
            </p>

            <p>
              For us, tree care is about more than just using a chainsaw. It is about understanding the biology of the tree, assessing every task with a trained eye, and executing the work with a precision that protects your property and leaves your garden in perfect condition.
            </p>

            <h2 className="text-2xl font-bold text-[#14291d] pt-4">Our Tree Care Services</h2>
            <p>
              We offer a comprehensive range of services related to trees. Whether a tree has grown too large, is diseased, or needs to make way for a new project – we have the right solution for you:
            </p>

            <ul className="space-y-3 list-disc pl-5">
              <li>
                <strong>Tree Felling:</strong> Safe and controlled felling of trees of all sizes. We analyze the lean, branch structure, and surroundings to determine the safest felling direction.
              </li>
              <li>
                <strong>Crown Reduction (Topkapning):</strong> When there is not enough space for a normal felling, we dismantle the tree piece by piece from the top down. This is especially important in densely built areas or near power lines.
              </li>
              <li>
                <strong>Tree Pruning:</strong> Professional pruning to promote tree health, remove dead branches, or let more light into your garden.
              </li>
              <li>
                <strong>Stump Grinding (Stubfræsning):</strong> After felling, we remove the remaining tree stump and roots with an effective stump grinder, allowing you to use the space immediately.
              </li>
              <li>
                <strong>Wood Chipping and Cleanup:</strong> Upon request, we can turn branches into wood chips for your garden beds, and we always leave your garden clean and tidy.
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-[#14291d] pt-4">Your Safety is Our Priority</h2>
            <ul className="space-y-2 list-disc pl-5">
              <li>
                <strong>Fully Insured:</strong> We are insured through Topdanmark for up to 10 million DKK.
              </li>
              <li>
                <strong>Highest Safety Standards:</strong> We strictly adhere to the rigorous rules of the Danish Working Environment Authority (Arbejdstilsynet) for safety and commercial climbing.
              </li>
              <li>
                <strong>Local Expertise:</strong> We are deeply rooted in the Jutland soil and serve cities such as Aarhus, Skanderborg, Horsens, Vejle, Fredericia, and Kolding.
              </li>
            </ul>

            <div className="bg-[#f2f7f4] rounded-2xl p-6 border border-[#cfe0d6] mt-8">
              <h3 className="text-lg font-bold text-[#14291d] mb-2">Company Details</h3>
              <p className="text-sm"><strong>Hærvejens Træpleje</strong></p>
              <p className="text-sm">Contact Person: Mathias Svendsen (Owner)</p>
              <p className="text-sm">Address: {COMPANY_INFO.address}, {COMPANY_INFO.postalCode} {COMPANY_INFO.city}, Denmark</p>
              <p className="text-sm">Phone: <a href="tel:+4527135787" className="font-bold underline">+45 27 13 57 87</a></p>
              <p className="text-sm">Email: <a href={`mailto:${COMPANY_INFO.email}`} className="font-bold underline">{COMPANY_INFO.email}</a></p>
              <p className="text-sm">CVR No. (VAT ID): {COMPANY_INFO.cvr}</p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <ContactForm
              title="Get a free quote"
              subtitle="Fill in the form below and we will get back to you within 24 hours."
            />
          </div>
        </div>
      </section>
    </>
  );
}
